// Vendor Libs
import {useDispatch, useSelector} from 'react-redux';

// Redux Actions
import {
  addDataPackage,
  createFolder,
  deleteFolder,
  removeDataPackage,
  resetFolder,
  setDataPackagesFromEntry,
  clearDataPackagesFromEntry,
  addSelectedDataPackagesFromEntry,
  setFolderData,
  setMode,
  updateFolder,
  viewFolder,
} from '../redux/actions/folder-actions';

export const useFolder = () => {
  const dispatch = useDispatch();

  return {
    folderData: useSelector(({folder: {folderData} = {}}) => folderData),
    folderToDelete: useSelector(({folder: {folderToDelete} = {}}) => folderToDelete),
    mode: useSelector(({folder: {mode} = {}}) => mode),
    dataPackagesFromEntry: useSelector(({folder: {dataPackagesFromEntry} = {}}) => dataPackagesFromEntry),
    addDataPackage: (...args) => dispatch(addDataPackage(...args)),
    deleteFolder: (...args) => {
      const [folderToDelete] = args;
      return Number.isFinite(+folderToDelete.launchId)
        ? // eslint-disable-next-line prefer-promise-reject-errors
          Promise.reject(`Cannot delete a folder with a launch ID. Launch ID: ${folderToDelete.launchId}`)
        : dispatch(deleteFolder(...args));
    },
    createFolder: (...args) => dispatch(createFolder(...args)),
    removeDataPackage: (...args) => dispatch(removeDataPackage(...args)),
    resetFolder: () => dispatch(resetFolder()),
    setFolderData: (...args) => dispatch(setFolderData(...args)),
    setMode: (...args) => dispatch(setMode(...args)),
    updateFolder: (...args) => dispatch(updateFolder(...args)),
    viewFolder: (...args) => dispatch(viewFolder(...args)),
    setDataPackagesFromEntry: (...args) => dispatch(setDataPackagesFromEntry(...args)),
    clearDataPackagesFromEntry: (...args) => dispatch(clearDataPackagesFromEntry(...args)),
    addSelectedDataPackagesFromEntry: (...args) => dispatch(addSelectedDataPackagesFromEntry(...args)),
  };
};
